import React from 'react';
/* import Axios library */
import Axios from 'axios';

function SearchFormFunctionalityHOC(mapPropsToData, WrappedSearchForm) {

    return class SearchFormWrapper extends React.Component {

        constructor(props) {
            super(props);
            
            //look for formData in sessionStorage for this window.  We store the formData
            //as a key like this: rjrformData_bw/public.  So the part after the "_" will match
            //the formBrand and formType in the URL.  This way we can keep different forms alive
            //in the same window.  If the sessionStorage doesn't exist, just set it to an empty object
            let formDataFromSessionStorage = sessionStorage.getItem(`rjrformData_${this.props.formBrand}/${this.props.formType}`) !== null ? JSON.parse(sessionStorage.getItem(`rjrformData_${this.props.formBrand}/${this.props.formType}`)) : {}

            /* in the searchForm state, form brand is the first part of the URL (rjr, atco, etc.). 
            Form type is the second part of the URL (public, confidential, etc.) */
            this.state = {
                formData:formDataFromSessionStorage
            }
        } 

        handleTextFieldChange = (e) => {

            let currentFormData = this.state.formData;

            if (e.target.value === '') {
                // remove the value from state
                let stateWithoutValue = this.removeBlankValuesFromState(e.target.id,currentFormData);
                this.setState({formData:stateWithoutValue});
            } else {
                currentFormData[e.target.id] = e.target.value;
                this.setState({formData:currentFormData});
            }
        }
        
        removeBlankValuesFromState(whichValue, currentState) {
            // this sets a constant with the key that we want to remove from state and a random value (foo)
            // then, the state without that value is spread into the currentFormData object. We then update the
            // state to reflect that state, effectively removing blank values from our state            
            const { [whichValue]: foo, ...stateWithoutValue } = currentState;
            return stateWithoutValue; 
        }

        //the date field components are a third party component that just sends the value of what the user entered
        //it doesn't send the event object.  So we made it send a custom object in the RJRDatePicker component
        handleDateFieldChange = (dateFieldDataObject) => {

            let currentFormData = this.state.formData;

            if (dateFieldDataObject.value === '') {
                //remove the value from state
                let stateWithoutValue = this.removeBlankValuesFromState(dateFieldDataObject.id,currentFormData);
                this.setState({formData:stateWithoutValue});
            } else {
                //update the state
                currentFormData[dateFieldDataObject.id] = dateFieldDataObject.value;
                this.setState({formData:currentFormData});
            }           
        }

        clearFormHandler(e) {
            this.setState({formData: {}});
        }

        buildSearchQuery = (ref) => {

            // I SHOULDN'T HAVE TO DO THIS!!!
            let self = this;
            //we need to get whatever data fields the user has filled out (held in state), 
            //get their field definitions, and then build a search string that we will use
            //when we make the actual search query in the searchResults component

            //just before you start to match up the field definitions to their IDs, store
            //the entire state in sessionStorage so it can be used to re-populate the form
            sessionStorage.setItem(`rjrformData_${this.props.formBrand}/${this.props.formType}`, JSON.stringify(this.state.formData));

            //need to get the field definitions from the JSON file
            Axios.get(process.env.PUBLIC_URL + '/static/fieldDefinitions.json')
            .then( (response) => {
                //the field definitions data comes through as array of options
                let fieldDefinitionsObject = response.data;
                let currentState = this.state.formData;
                let queryStringArray = [];

                // //iterate through the keys of the formData object..this represents
                //all the fields that the user has entered data in
                Object.keys(currentState).forEach(function(formDataKey) {
                    //for each field that has data, iterate through the object keys of the fieldDefinitions. The field definition keys
                    //match the keys in the form data (which we derive from the HTML id attribute).  That will get you the field definition ID
                    //which needs to be sent in the query
                    Object.keys(fieldDefinitionsObject).forEach(function(fieldDefinitionKey) {
                        if (fieldDefinitionKey === formDataKey) {
                            var value = currentState[formDataKey];
                            if(value.indexOf('"') === -1 && value.indexOf('*') === -1 && formDataKey !== 'combinedText' && !fieldDefinitionsObject[fieldDefinitionKey].isDateField) {
                                if(formDataKey.toLowerCase().indexOf('copyee') > -1 || formDataKey.toLowerCase().indexOf('addressee') > -1 
                                    || formDataKey.toLowerCase().indexOf('author') > -1 || formDataKey.toLowerCase() === 'title') {
                                    value = value + '*';
                                }
                            }
                            
                            var pattern = new RegExp(/[~`!#$%\^&+=\-\[\]\\';,/{}|\\":<>\?]/);
                            if(!fieldDefinitionsObject[fieldDefinitionKey].isDateField && pattern.test(value)) {
                                //+ - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
                                value = value.replace(/\*/g,'\\*');
                            }

                            if(fieldDefinitionsObject[fieldDefinitionKey].isDateField) {
                                value = value.replace(/\*/g,'');
                                value = '/.*' + value + '.*/';
                            }
                                                        
                            //These fields should split by commas and OR the search
                            if(formDataKey === 'documentIdBegin' || formDataKey === 'documentIdEnd') {
                                value = value.replace(/,/g,'"||"')
                                queryStringArray.push((`${fieldDefinitionsObject[fieldDefinitionKey].id}:("${value}")`)); 
                            }                         
                            else if (formDataKey === 'combinedText') {
                                queryStringArray.unshift(value);
                            } 
                            else {
                                //anything else goes into the search string with the label and a value
                                queryStringArray.push((`${fieldDefinitionsObject[fieldDefinitionKey].id}:${value}`)); 
                            } 
                        }
                    });                    
                });    
                
                //make one comma string out of all the search terms 
                let queryString = queryStringArray.join(' ');                
                               
                //if you have a URL, go to the search results routs
                self.props.searchRequestHandler(queryString);

            });
        }
             
        render() {
            // Simply render the WrappedComponent with all props
            return <WrappedSearchForm 
                textFieldHandler={this.handleTextFieldChange.bind(this)}
                clearFormHandler={this.clearFormHandler.bind(this)} 
                dateFieldHandler={this.handleDateFieldChange.bind(this)} 
                modalHandler={this.props.loadModalFieldData}
                searchHandler={this.buildSearchQuery.bind(this)} 
                formData={this.state.formData}
                {...this.props} 
            />;
        }        


    }

}

export default SearchFormFunctionalityHOC;

  


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormWrapper.js